import React from 'react';
import { generateSequentialArray } from '@ajaibid/utils';

import SkeletonLoading from '@/components/SkeletonLoading';

function getRowCount({
  isInitialLoading,
  isFetchingNext,
}: {
  isInitialLoading: boolean;
  isFetchingNext: boolean;
}) {
  switch (true) {
    case isInitialLoading:
      return 3;

    case isFetchingNext:
      return 2;

    default:
      return 0;
  }
}

function RowLoader({
  cellCount,
  isInitialLoading,
  isFetchingNext,
}: {
  cellCount: number;
  isInitialLoading: boolean;
  isFetchingNext: boolean;
}) {
  const rowCount = getRowCount({ isInitialLoading, isFetchingNext });

  return (
    <>
      {generateSequentialArray(rowCount).map((rowKey) => (
        <tr key={rowKey}>
          {generateSequentialArray(cellCount).map((cellKey) => (
            <td key={cellKey}>
              <SkeletonLoading style={{ height: '20px' }} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}

export default RowLoader;
